import React, { ChangeEvent, useCallback } from "react";
import { setObjectValue } from "./setObjectValue";

export function useFormInputChange<T = Record<string, unknown>>(
  data: T,
  setter: React.Dispatch<React.SetStateAction<T>>,
  onChange?: (event) => void,
) {
  return useCallback(
    (event: ChangeEvent<HTMLInputElement>): void => {
      if (event.target.name) {
        setter(setObjectValue(data, event.target.name, event.target.value));
      }
      onChange && onChange(event);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, onChange, setter],
  );
}

export function useFormCheckboxChange<T = Record<string, unknown>>(
  data: T,
  setter: React.Dispatch<React.SetStateAction<T>>,
  onChange?: (event) => void,
) {
  return useCallback(
    (event: ChangeEvent<HTMLInputElement>): void => {
      if (event.target.name) {
        setter(setObjectValue(data, event.target.name, !!event.target.checked));
      }
      onChange && onChange(event);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, onChange, setter],
  );
}

export function useFormModelChange<T = Record<string, unknown>>(
  data: T,
  setter: React.Dispatch<React.SetStateAction<T>>,
  onChange?: (event) => void,
) {
  return useCallback(
    (event: ChangeEvent<HTMLInputElement>, parsedValue) => {
      if (event.target.name) {
        setter(setObjectValue(data, event.target.name, parsedValue));
      }
      onChange && onChange(event);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, onChange, setter],
  );
}
